import {useState, useRef, useEffect} from 'react';
import {Container, Card, Image, Tab, Segment} from 'semantic-ui-react';

import {useWindowWidth} from 'hooks/useWindowWidth';

import Services from './Services/Services';
import {categories} from './servicesDefinition';

import styles from './LandingPageCategories.module.scss';

const LandingPageCategories = () => {
  const [selectedCard, setSelectedCard] = useState();
  const [selectedMenu, setSelectedMenu] = useState();
  const width = useWindowWidth();
  const descriptionRef = useRef(null);

  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.scrollIntoView({behavior: 'smooth'});
    }
  }, [selectedCard]);

  const handleSelectedCardAndMenu = index => {
    setSelectedCard(index);
    setSelectedMenu(Math.floor(index / 3));
  };

  const panes = categories.map((category, index) => ({
    menuItem: (
      <Card
        active={undefined}
        key={index}
        className={selectedCard === index ? styles.SelectedCard : styles.CategoryCard}
        onClick={() => handleSelectedCardAndMenu(index)}
      >
        <Card.Content>
          <div className={styles.ServiceIconContainer}>
            <Image alt={category.title} size="tiny" src={category.icon} />
          </div>
          <Card.Header>{category.title}</Card.Header>
          <Card.Description
            className={index === 0 ? styles.DescriptionWithHyphens : styles.Description}
          >
            {category.description}
          </Card.Description>
        </Card.Content>
      </Card>
    ),
    render: function categoryFunction() {
      return (
        <Tab.Pane className={styles.ServiceContainer} attached={false}>
          <div ref={descriptionRef} className={styles.Scroll}>
            <Services services={category.services} />
          </div>
        </Tab.Pane>
      );
    },
  }));

  return (
    <Container className={styles.LandingPageCategories}>
      {width > 700 ? (
        // Big screens
        <>
          <Segment key="top" className={styles.Segment}>
            <Tab
              activeIndex={selectedMenu === 0 ? selectedCard : null}
              menu={{
                secondary: true,
                style: {
                  justifyContent: 'space-between',
                  margin: 0,
                },
              }}
              panes={panes.slice(0, 3)}
            />
          </Segment>
          <Segment key="bottom" className={styles.Segment}>
            {/* selectedCard - 3 because it's a new Tab, so index starts by 0 again */}
            <Tab
              activeIndex={selectedMenu === 1 ? selectedCard - 3 : null}
              menu={{
                secondary: true,
                style: {
                  justifyContent: 'space-between',
                  margin: 0,
                },
              }}
              panes={panes.slice(3, 6)}
            />
          </Segment>
        </>
      ) : (
        // Small screens
        <>
          {panes.map((pane, key) => {
            return (
              <Segment key={key} className={styles.Segment}>
                <Tab
                  activeIndex={selectedCard === key ? 0 : null}
                  menu={{
                    secondary: true,
                    style: {
                      justifyContent: 'space-around',
                      margin: 0,
                    },
                  }}
                  panes={[pane]}
                />
              </Segment>
            );
          })}
        </>
      )}
    </Container>
  );
};

export default LandingPageCategories;
